export const magazines = [
    {
      id: 1,
      name: "Salsabeel",
      description: "A spiritual and educational magazine",
      details: "Yearly Magazine - 2 Issues",
      color: "#d4f5e9",
      icon: "🕌"
    },
    {
      id: 2,
      name: "Ar rushd",
      description: "Academic research and scholarly articles",
      details: "Bi-Monthly Magazine - 2 Issues",
      color: "#dbeafe",
      icon: "📚"
    },
    {
      id: 3,
      name: "General",
      description: "In-depth research on Islamic studies",
      details: "On Demand Magazine - 1 Issue",
      color: "#f3e8ff",
      icon: "🧑‍🎓"
    }
  ];
  